import { CircularProgress } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  //max-width: 25rem;

  p {
    text-align: center;
  }
`;

export const WrapperLoading = styled(CircularProgress)`
  margin-top: 3rem;
`;
